// @flow
import {getCreator} from '../../http';
import environment from '../../environment';

//const OVERPASS_API = 'https://overpass-api.de/api/interpreter';
const NOMINATIN_API = 'https://nominatim.openstreetmap.org/search';

export const endpoints = Object.freeze({
  GET_PLACE_DETAIL: `${environment.baseApiUrl}/im/location/place-detail`,
  GET_GEOMETRY: `${environment.baseApiUrl}/im/location/place-geometry`,
  AUTOCOMPLETE: `${environment.baseApiUrl}/im/location/autocomplete`,
  FETCH_LOCATION: `${environment.baseApiUrl}/im/location`,
  FETCH_OSM_SUGGESTIONS: NOMINATIN_API,
});

export const getPlaceIdApi = getCreator(endpoints.GET_PLACE_DETAIL);
export const getPolygonApi = getCreator(endpoints.GET_GEOMETRY);
export const getPlacePredictionsApi = getCreator(endpoints.AUTOCOMPLETE);
export const getOSMSuggestionsApi = getCreator(endpoints.FETCH_OSM_SUGGESTIONS);
